import React from 'react';

import {Button, Icon, TooltipStateful} from 'client/common/components/lego';

import {IconButtonProps} from './types';

export default function IconButton(props: IconButtonProps) {
    const {
        iconDirection,
        iconSize,
        scope,
        content,
        boundary,
        trigger = ['hover', 'click', 'focus'],
        tooltipClassname = '',
        tooltipDirection,
        mainOffset = 8,
        type,
        view = 'clear',
        children,
        ...rest
    } = props;

    const button = (
        <Button
            icon={(iconClassName: string) => (
                <Icon
                    className={iconClassName}
                    direction={iconDirection}
                    size={iconSize}
                    type={type}
                />
            )}
            size='icon'
            view={view}
            {...rest}
        >
            {children}
        </Button>
    );

    if (!content) {
        return button;
    }

    return (
        <TooltipStateful
            content={content}
            className={tooltipClassname}
            direction={tooltipDirection ?? ['top', 'right', 'left']}
            mainOffset={mainOffset}
            size='s'
            trigger={trigger}
            view='default'
            zIndex={1001}
            keepMounted={false}
            scope={scope}
            boundary={boundary}
            openDelay={500}
        >
            {button}
        </TooltipStateful>
    );
}
